import { createAction } from 'redux-actions';

export const setNotificationStatus = createAction(
  'app/SET_NOTIFICATION_STATUS'
);
